import { useEffect } from 'react';
import { t } from '../i18n';

/**
 * Edits typed into Configuración and not saved yet.
 *
 * Each card there saves on its own, so one wrong field never holds back another
 * card, which also means a card can be left half edited. The app runs on a plain
 * BrowserRouter, which cannot hold a navigation back, so whatever leaves on
 * purpose (the menu, the tabs, sign-out, the buttons that lead to another
 * screen) asks confirmLeaving() first, and a reload or a closed tab gets the
 * browser's own question. The browser's back button is not asked about.
 */

const unsaved = new Set();

const warnBeforeUnload = (event) => {
  event.preventDefault();
  // Some browsers show their question only when returnValue is set.
  event.returnValue = '';
};

export const setUnsaved = (key, isUnsaved) => {
  const hadAny = unsaved.size > 0;
  if (isUnsaved) unsaved.add(key);
  else unsaved.delete(key);
  const hasAny = unsaved.size > 0;
  if (!hadAny && hasAny) window.addEventListener('beforeunload', warnBeforeUnload);
  if (hadAny && !hasAny) window.removeEventListener('beforeunload', warnBeforeUnload);
};

export const hasUnsaved = () => unsaved.size > 0;

/** True when nothing is unsaved, or when the person agrees to lose it. */
export const confirmLeaving = () => !hasUnsaved() || window.confirm(t('settings.unsavedConfirm'));

/** Marks a card unsaved while `isUnsaved` holds, and forgets it when the card goes. */
export const useUnsaved = (key, isUnsaved) => {
  useEffect(() => {
    setUnsaved(key, isUnsaved);
    return () => setUnsaved(key, false);
  }, [key, isUnsaved]);
};
